import { render, staticRenderFns } from "./PayoutSwish.vue?vue&type=template&id=26f87d20&scoped=true&lang=pug&"
import script from "./PayoutSwish.vue?vue&type=script&lang=js&"
export * from "./PayoutSwish.vue?vue&type=script&lang=js&"
import style0 from "./PayoutSwish.vue?vue&type=style&index=0&id=26f87d20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f87d20",
  null
  
)

export default component.exports